
require.register("react/react.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {"transform":["envify"]}, "react");
  (function() {
    'use strict';

module.exports = require('./lib/React');
  })();
});